import { API_BASE as API_URL, getToken} from '../../../../lib/api';
// ERP Attribute Engine — Attribute Service

function authHeaders() {
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` };
}

async function apiFetch(url, options = {}) {
  const res = await fetch(`${API_URL}${url}`, { ...options, headers: { ...authHeaders(), ...(options.headers || {}) } });
  const json = await res.json();
  if (!json.success) throw new Error(json.error || 'API error');
  return json.data;
}

// NOTE: points at the LEGACY engine (/api/attribute-engine-legacy), restored as its own
// namespace so it doesn't collide with the new real-DB Attribute & Pricing Studio which
// now owns /api/attribute-engine/attributes + /api/attribute-engine/industries.
export const AttributeService = {
  getAttributes: (industry) =>
    apiFetch(industry ? `/api/attribute-engine-legacy/attributes?industry=${industry}` : '/api/attribute-engine-legacy/attributes'),

  saveAttribute: (attr) =>
    apiFetch('/api/attribute-engine-legacy/attributes', { method: 'POST', body: JSON.stringify(attr) }),

  deleteAttribute: (id) =>
    apiFetch(`/api/attribute-engine-legacy/attributes/${id}`, { method: 'DELETE' }),

  getIndustries: () =>
    apiFetch('/api/attribute-engine-legacy/industries'),

  getLayouts: (industry) =>
    apiFetch(industry ? `/api/attribute-engine-legacy/layouts?industry=${industry}` : '/api/attribute-engine-legacy/layouts'),

  saveLayout: (layout) =>
    apiFetch('/api/attribute-engine-legacy/layouts', { method: 'POST', body: JSON.stringify(layout) }),

  getSolutions: (industry) =>
    apiFetch(industry ? `/api/attribute-engine-legacy/solutions?industry=${industry}` : '/api/attribute-engine-legacy/solutions'),

  saveSolution: (solution) =>
    apiFetch('/api/attribute-engine-legacy/solutions', { method: 'POST', body: JSON.stringify(solution) }),

  getCompanyConfig: () =>
    apiFetch('/api/attribute-engine-legacy/company/config'),

  saveCompanyConfig: (config) =>
    apiFetch('/api/attribute-engine-legacy/company/config', { method: 'POST', body: JSON.stringify(config) }),

  getFullConfig: (solutionId) =>
    apiFetch(`/api/attribute-engine-legacy/config/${solutionId}`),
};
